<template>
  <div class="my-content">
    <div class="left-content">
      <Card>
        <p slot="title">{{ $t("Level_one") + $t("extract") }}</p>
        <Form
          label-position="right"
          :model="dataDetails"
          :label-width="140"
          :rules="ruleFrom"
          ref="dataDetails"
        >
          <Row :gutter="10">
            <Col span="8">
              <FormItem :label="$t('mawb')" prop="mawb">
                <i-Input
                  v-model="dataDetails.mawb"
                  :placeholder="$t('enter') + $t('mawb')"
                ></i-Input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem :label="$t('carrier_code')" prop="carrier_code">
                <Select
                  v-model="dataDetails.carrier_code"
                  filterable
                  :placeholder="$t('select') + $t('carrier_code')"
                  clearable
                  :filter-by-label="true"
                  @on-change="changeCarrier"
                >
                  <Option
                    v-for="(item, index) in carrierObj"
                    :value="index"
                    :key="index"
                    :label="item"
                    >{{ item }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem :label="$t('shipping_mode')" prop="shipping_mode">
                <Select
                  v-model="dataDetails.shipping_mode"
                  filterable
                  :placeholder="$t('select') + $t('shipping_mode')"
                  clearable
                  :filter-by-label="true"
                >
                  <Option
                    v-for="item in shippingModeList"
                    :value="item.key"
                    :key="item.key"
                    :label="item.name"
                    >{{ item.name }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem :label="$t('hub')" prop="hub">
                <Select
                  v-model="dataDetails.hub"
                  filterable
                  :placeholder="$t('select') + $t('hub')"
                  clearable
                  :filter-by-label="true"
                >
                  <Option
                    v-for="item in hubList"
                    :value="item.key"
                    :key="item.key"
                    :label="item.name"
                    >{{ item.name }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem :label="$t('from_station')" prop="from_station">
                <Select
                  v-model="dataDetails.from_station"
                  filterable
                  :placeholder="$t('select') + $t('from_station')"
                  clearable
                  :filter-by-label="true"
                  @on-change="handCheck"
                >
                  <Option
                    v-for="item in fromStationList"
                    :value="item.key"
                    :key="item.key"
                    :label="item.name"
                    >{{ item.name }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem :label="$t('to_station')" prop="to_station">
                <Select
                  v-model="dataDetails.to_station"
                  filterable
                  :placeholder="$t('select') + $t('to_station')"
                  clearable
                  :filter-by-label="true"
                  @on-change="changeTo('to_station')"
                >
                  <Option
                    v-for="item in toStationList"
                    :value="item.key"
                    :key="item.key"
                    :label="item.name"
                    >{{ item.name }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem :label="$t('DestinationCity')" prop="to_city">
                <i-Input
                  v-model="dataDetails.to_city"
                  :placeholder="$t('enter') + $t('DestinationCity')"
                ></i-Input>
              </FormItem>
            </Col>

            <Col span="8">
              <FormItem :label="$t('departureAirport')" prop="from_port">
                <Select
                  v-model="dataDetails.from_port"
                  filterable
                  :placeholder="$t('select') + $t('departureAirport')"
                  clearable
                  :filter-by-label="true"
                >
                  <Option
                    v-for="item in airportList"
                    :value="item.code"
                    :key="item.code"
                    :label="item.code"
                    >{{ item.code }}</Option
                  >
                </Select>
              </FormItem>
            </Col>

            <Col span="8">
              <FormItem :label="$t('destinationAirport')" prop="to_port">
                <Select
                  v-model="dataDetails.to_port"
                  filterable
                  :placeholder="$t('select') + $t('destinationAirport')"
                  clearable
                  :filter-by-label="true"
                >
                  <Option
                    v-for="item in airportList1"
                    :value="item.value"
                    :key="item.value"
                    :label="item.label"
                    >{{ item.label }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem :label="$t('flight')" prop="flight">
                <i-Input
                  v-model="dataDetails.flight"
                  :placeholder="$t('enter') + $t('flight')"
                ></i-Input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem :label="$tz('中转,机场')" prop="mid_port">
                <Select
                  v-model="dataDetails.mid_port"
                  filterable
                  :placeholder="$tz('请选择,中转,机场')"
                  clearable
                  :filter-by-label="true"
                >
                  <Option
                    v-for="item in airportList"
                    :value="item.code"
                    :key="item.code"
                    :label="item.code"
                    >{{ item.code }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem :label="$tz('航班,频次')" prop="frequency">
                <i-Input
                  v-model="dataDetails.frequency"
                  :placeholder="$tz('请输入,航班,频次')"
                ></i-Input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem :label="$t('dept_date')" prop="dept_date">
                <DatePicker
                  type="datetime"
                  :placeholder="$t('select') + $t('dept_date')"
                  style="width: 100%"
                  :value="dataDetails.dept_date"
                  @on-change="dataDetails.dept_date = $event"
                >
                </DatePicker>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem :label="$t('expected_date')" prop="expected_date">
                <DatePicker
                  type="datetime"
                  :placeholder="$t('select') + $t('expected_date')"
                  style="width: 100%"
                  :value="dataDetails.expected_date"
                  @on-change="dataDetails.expected_date = $event"
                ></DatePicker>
              </FormItem>
            </Col>

            <Col span="8">
              <FormItem :label="$t('load_type')" prop="load_type">
                <Select
                  v-model="dataDetails.load_type"
                  filterable
                  :placeholder="$t('select') + $t('load_type')"
                  clearable
                  :filter-by-label="true"
                >
                  <Option
                    v-for="item in loadTypeList"
                    :value="item.key"
                    :key="item.key"
                    :label="item.name"
                    >{{ item.name }}</Option
                  >
                </Select>
              </FormItem>
            </Col>

            <!-- <Col span="12">
              <FormItem :label="$t('number_of_bags')" prop="number_of_bags">
                <i-Input
                  v-model="dataDetails.number_of_bags"
                  placeholder="Please Enter number_of_bags"
                ></i-Input>
              </FormItem>
            </Col> -->

            <Col span="8">
              <FormItem :label="$t('Weight')" prop="weight">
                <i-Input
                  v-model="dataDetails.weight"
                  :placeholder="$t('enter') + $t('Weight')"
                ></i-Input>
              </FormItem>
            </Col>
            <!-- <Col span="8">
              <FormItem :label="$t('charge_params')" prop="charging_weight">
                <i-Input
                  v-model="dataDetails.charging_weight"
                  :placeholder="$t('enter') + $t('charge_params')"
                ></i-Input>
              </FormItem>
            </Col> -->
            <Col span="8">
              <FormItem :label="$t('charge_volume')" prop="volume_weight">
                <i-Input
                  v-model="dataDetails.volume_weight"
                  :placeholder="$t('enter') + $t('charge_volume')"
                ></i-Input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem :label="$tz('是否,整板,类型')" prop="board_type">
                <Select
                  v-model="dataDetails.board_type"
                  filterable
                  :placeholder="$tz('是否,整板,类型')"
                  clearable
                  :filter-by-label="true"
                  @on-change="handCheck"
                >
                  <Option
                    v-for="item in board_type"
                    :value="item.value"
                    :key="item.value"
                    :label="item.label"
                    >{{ item.label }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem :label="$t('clearagent')" prop="clearance_agent">
                <Select
                  v-model="dataDetails.clearance_agent"
                  filterable
                  :placeholder="$t('select') + $t('clearagent')"
                  clearable
                  :filter-by-label="true"
                  @on-change="handCheck"
                >
                  <Option
                    v-for="item in clearList"
                    :value="item.key"
                    :key="item.key"
                    :label="item.name"
                    >{{ item.name }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem :label="$t('air_agent')" prop="air_agent">
                <Select
                  v-model="dataDetails.air_agent"
                  filterable
                  :placeholder="$t('select') + $t('air_agent')"
                  clearable
                  filter-by-label
                >
                  <Option
                    v-for="item in airList"
                    :value="item.agent_name"
                    :key="item.agent_name"
                    :label="item.agent_name"
                  ></Option>
                </Select>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem
                :label="$t('warehousCustomsAgent')"
                prop="baoguan_agent"
              >
                <Select
                  v-model="dataDetails.baoguan_agent"
                  filterable
                  :placeholder="$t('select') + $t('warehousCustomsAgent')"
                  clearable
                  filter-by-label
                >
                  <Option
                    v-for="item in baoguanList"
                    :value="item.agent_name"
                    :key="item.agent_name"
                    :label="item.agent_name"
                  ></Option>
                </Select>
              </FormItem>
            </Col>
            <!-- <Col span="12">
              <FormItem :label="$t('number_of_shipment')" prop="number_of_shipment">
                <i-Input
                  v-model="dataDetails.number_of_shipment"
                  placeholder="Please Enter number_of_shipment"
                ></i-Input>
              </FormItem>
            </Col> -->
            <Col span="8">
              <FormItem :label="$t('HKagency')" prop="hk_agent">
                <Select
                  v-model="dataDetails.hk_agent"
                  filterable
                  :placeholder="$t('select') + $t('HKagency')"
                  clearable
                  filter-by-label
                >
                  <Option
                    v-for="item in HkList"
                    :value="item.agent_name"
                    :key="item.agent_name"
                    :label="item.agent_name"
                  ></Option>
                </Select>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem :label="$tz('文件,代理')" prop="file_agent">
                <Select
                  v-model="dataDetails.file_agent"
                  filterable
                  :placeholder="$tz('请选择,文件,代理')"
                  clearable
                  filter-by-label
                >
                  <Option
                    v-for="item in transportAgentList"
                    :value="item.label"
                    :key="item.label"
                    :label="item.label"
                  ></Option>
                </Select>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem
                :label="$t('extract') + $t('Weight')"
                prop="extract_weight"
              >
                <i-Input
                  v-model="dataDetails.extract_weight"
                  :placeholder="$t('enter') + $t('extract') + $t('Weight')"
                ></i-Input>
              </FormItem>
            </Col>
            <Col span="16">
              <FormItem :label="$t('Remarks')" prop="remarks">
                <i-Input
                  type="textarea"
                  v-model="dataDetails.remarks"
                  :placeholder="$t('enter') + $t('Remarks')"
                ></i-Input>
              </FormItem>
            </Col>
            <Col span="24">
              <FormItem :label="$t('packing_number')" prop="packing_number">
                <div class="bag-code">
                  <template v-if="packList.length > 0">
                    <div class="check-all">
                      <Checkbox :value="checkAll" @on-change="handleCheckAll">
                        {{ $t("all") }}
                      </Checkbox>
                    </div>
                    <div class="check-client">
                      <CheckboxGroup
                        v-model="dataDetails.packing_number"
                        @on-change="checkAllGroupChange"
                      >
                        <Row :gutter="10">
                          <Col
                            span="8"
                            v-for="item in packList"
                            :key="item.id"
                            style="margin-bottom: 10px"
                          >
                            <Checkbox
                              :label="item.packing_number"
                              border
                            ></Checkbox>
                          </Col>
                        </Row>
                      </CheckboxGroup>
                    </div>
                  </template>
                </div>
              </FormItem>
            </Col>
            <Col v-if="b2bPackList.length > 0" span="24">
              <FormItem :label="$t('b2bPackingList')" prop="dbl_packing">
                <div class="bag-code">
                  <template>
                    <div class="check-all">
                      <Checkbox
                        :value="b2bCheckAll"
                        @on-change="b2bCheckAllChange"
                      >
                        {{ $t("all") }}
                      </Checkbox>
                    </div>
                    <div class="check-client">
                      <CheckboxGroup
                        v-model="dataDetails.dbl_packing"
                        @on-change="b2bcheckAllGroupChange"
                      >
                        <Row :gutter="10">
                          <Col
                            span="8"
                            v-for="item in b2bPackList"
                            :key="item.id"
                            style="margin-bottom: 10px"
                          >
                            <Checkbox
                              :label="item.packing_number"
                              border
                            ></Checkbox>
                          </Col>
                        </Row>
                      </CheckboxGroup>
                    </div>
                  </template>
                </div>
              </FormItem>
            </Col>
          </Row>
        </Form>
      </Card>
      <Card style="margin-top: 20px" v-if="isSecond">
        <p slot="title">{{ $t("Level_two") + $t("extract") }}</p>
        <Form
          label-position="right"
          :model="relation"
          :label-width="140"
          :rules="relRuleFrom"
          ref="relation"
        >
          <Row :gutter="10">
            <Col span="8">
              <FormItem :label="$t('mawb')" prop="mawb">
                <i-Input
                  v-model="relation.mawb"
                  :placeholder="$t('enter') + $t('mawb')"
                ></i-Input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem :label="$t('shipping_mode')" prop="shipping_mode">
                <Select
                  v-model="relation.shipping_mode"
                  filterable
                  :placeholder="$t('select') + $t('shipping_mode')"
                  clearable
                  :filter-by-label="true"
                >
                  <Option
                    v-for="item in shippingModeList"
                    :value="item.key"
                    :key="item.key"
                    :label="item.name"
                    >{{ item.name }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem :label="$t('load_type')" prop="load_type">
                <Select
                  v-model="relation.load_type"
                  filterable
                  :placeholder="$t('select') + $t('load_type')"
                  clearable
                  :filter-by-label="true"
                >
                  <Option
                    v-for="item in loadTypeList"
                    :value="item.key"
                    :key="item.key"
                    :label="item.name"
                    >{{ item.name }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem :label="$t('airLine')" prop="air_line">
                <Select
                  v-model="relation.air_line"
                  filterable
                  :placeholder="$t('select') + $t('airLine')"
                  clearable
                  :filter-by-label="true"
                >
                  <Option
                    v-for="item in airLineList"
                    :value="item.value"
                    :key="item.value"
                    :label="item.label"
                    >{{ item.label }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem :label="$t('departureAirport')" prop="from_port">
                <Select
                  v-model="relation.from_port"
                  filterable
                  :placeholder="$t('select') + $t('departureAirport')"
                  clearable
                  :filter-by-label="true"
                >
                  <Option
                    v-for="item in airportList"
                    :value="item.code"
                    :key="item.code"
                    :label="item.code"
                    >{{ item.code }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem :label="$t('destinationAirport')" prop="to_port">
                <Select
                  v-model="relation.to_port"
                  filterable
                  :placeholder="$t('select') + $t('destinationAirport')"
                  clearable
                  :filter-by-label="true"
                >
                  <Option
                    v-for="item in airportList"
                    :value="item.code"
                    :key="item.code"
                    :label="item.code"
                    >{{ item.code }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem :label="$t('flight')" prop="flight">
                <i-Input
                  v-model="relation.flight"
                  :placeholder="$t('enter') + $t('flight')"
                ></i-Input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem :label="$t('dept_date')" prop="dept_date">
                <DatePicker
                  type="datetime"
                  :placeholder="$t('select') + $t('dept_date')"
                  style="width: 100%"
                  :value="relation.dept_date"
                  @on-change="relation.dept_date = $event"
                >
                </DatePicker>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem :label="$t('expected_date')" prop="expected_date">
                <DatePicker
                  type="datetime"
                  :placeholder="$t('select') + $t('expected_date')"
                  style="width: 100%"
                  :value="relation.expected_date"
                  @on-change="relation.expected_date = $event"
                ></DatePicker>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem :label="$t('from_station')" prop="from_station">
                <Select
                  v-model="relation.from_station"
                  filterable
                  :placeholder="$t('select') + $t('from_station')"
                  clearable
                  :filter-by-label="true"
                  @on-change="handCheck"
                >
                  <Option
                    v-for="item in fromStationList"
                    :value="item.key"
                    :key="item.key"
                    :label="item.name"
                    >{{ item.name }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem :label="$t('to_station')" prop="to_station">
                <Select
                  v-model="relation.to_station"
                  filterable
                  :placeholder="$t('select') + $t('to_station')"
                  clearable
                  :filter-by-label="true"
                  @on-change="changeTo"
                >
                  <Option
                    v-for="item in toStationList"
                    :value="item.key"
                    :key="item.key"
                    :label="item.name"
                    >{{ item.name }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem :label="$t('DestinationCity')" prop="to_city">
                <i-Input
                  v-model="relation.to_city"
                  :placeholder="$t('enter') + $t('DestinationCity')"
                ></i-Input>
              </FormItem>
            </Col>
            <!-- <Col span="12">
              <FormItem :label="$t('number_of_bags')" prop="number_of_bags">
                <i-Input
                  v-model="number_of_bags"
                  placeholder="Please Enter number_of_bags"
                ></i-Input>
              </FormItem>
            </Col> -->
            <Col span="8">
              <FormItem :label="$t('Weight')" prop="weight">
                <i-Input
                  v-model="relation.weight"
                  :placeholder="$t('enter') + $t('Weight')"
                ></i-Input>
              </FormItem>
            </Col>
            <!-- <Col span="8">
              <FormItem :label="$t('charge_params')" prop="charging_weight">
                <i-Input
                  v-model="relation.charging_weight"
                  :placeholder="$t('enter') + $t('charge_params')"
                ></i-Input>
              </FormItem>
            </Col> -->
            <Col span="8">
              <FormItem :label="$t('charge_volume')" prop="volume_weight">
                <i-Input
                  v-model="relation.volume_weight"
                  :placeholder="$t('enter') + $t('charge_volume')"
                ></i-Input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem
                :label="$t('extract') + $t('Weight')"
                prop="extract_weight"
              >
                <i-Input
                  v-model="relation.extract_weight"
                  :placeholder="$t('enter') + $t('extract') + $t('Weight')"
                ></i-Input>
              </FormItem>
            </Col>
            <!-- <Col span="8">
              <FormItem :label="$t('invoicePCS')" prop="quantity">
                <i-Input
                  v-model="relation.quantity"
                  :placeholder="$t('enter') + $t('invoicePCS')"
                ></i-Input>
              </FormItem>
            </Col> -->

            <Col span="8">
              <FormItem :label="$t('clearagent')" prop="clearance_agent">
                <Select
                  v-model="relation.clearance_agent"
                  filterable
                  :placeholder="$t('select') + $t('clearagent')"
                  clearable
                  :filter-by-label="true"
                  @on-change="handCheck"
                >
                  <Option
                    v-for="item in clearList"
                    :value="item.key"
                    :key="item.key"
                    :label="item.name"
                    >{{ item.name }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem :label="$t('air_agent')" prop="air_agent">
                <Select
                  v-model="relation.air_agent"
                  filterable
                  :placeholder="$t('select') + $t('air_agent')"
                  clearable
                  filter-by-label
                >
                  <Option
                    v-for="item in airList"
                    :value="item.agent_name"
                    :key="item.agent_name"
                    :label="item.agent_name"
                  ></Option>
                </Select>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem
                :label="$t('warehousCustomsAgent')"
                prop="baoguan_agent"
              >
                <Select
                  v-model="relation.baoguan_agent"
                  filterable
                  :placeholder="$t('select') + $t('warehousCustomsAgent')"
                  clearable
                  filter-by-label
                >
                  <Option
                    v-for="item in baoguanList"
                    :value="item.agent_name"
                    :key="item.agent_name"
                    :label="item.agent_name"
                  ></Option>
                </Select>
              </FormItem>
            </Col>
            <!-- <Col span="8">
              <FormItem :label="$t('HKagency')">
                <Select
                  v-model="relation.hk_agent"
                  filterable
                  :placeholder="$t('select') + $t('HKagency')"
                  clearable
                  filter-by-label
                >
                  <Option
                    v-for="item in HkList"
                    :value="item.agent_name"
                    :key="item.agent_name"
                    :label="item.agent_name"
                  ></Option>
                </Select>
              </FormItem>
            </Col> -->
            <Col span="24">
              <FormItem :label="$t('Remarks')" prop="remarks">
                <i-Input
                  type="textarea"
                  v-model="relation.remarks"
                  :placeholder="$t('enter') + $t('Remarks')"
                ></i-Input>
              </FormItem>
            </Col>
          </Row>
        </Form>
      </Card>
      <div class="btn-div">
        <Button
          :type="isSecond ? 'error' : 'success'"
          class="submit-btn"
          size="large"
          @click="secondClick"
          :icon="isSecond ? 'md-close' : 'md-add'"
        >
          {{ (isSecond ? $t("cancel") : "") + $t("newSecond") }}
        </Button>
        <Button
          type="primary"
          class="submit-btn"
          size="large"
          @click="submitClick"
          icon="md-add"
        >
          {{ $t("order_submit") }}
        </Button>
      </div>
    </div>
    <div class="right-content">
      <!-- <div class="search-div">
        <Form :model="searchFrom" inline ref="searchFrom">
          <FormItem>
            <Select
              v-model="searchFrom.target_airport"
              filterable
              clearable
              placeholder="Please Select airport"
            >
              <Option
                v-for="item in fromStationList"
                :value="item.key"
                :key="item.key"
                >{{ item.name }}</Option
              >
            </Select>
          </FormItem>
          <FormItem>
            <i-Input
              v-model="searchFrom.packing_number"
              placeholder="Please Enter packingNum"
            >
            </i-Input>
          </FormItem>
          <FormItem>
            <Button
              type="primary"
              @click="SearchSubmit(searchFrom)"
              icon="md-search"
            >
              {{ $t("search") }}
            </Button>
          </FormItem>
          <FormItem>
            <Button type="error" @click="resetSubmit">
              {{ $t("order_reset") }}
            </Button>
          </FormItem>
        </Form>
      </div> -->
      <Table
        border
        :columns="tableTitle"
        :data="tableData"
        stripe
        :loading="loading"
        height="750"
      ></Table>
    </div>
  </div>
</template>

<script>
import {
  getExtractConfig,
  postPack,
  add,
  getClearancePacking,
  getB2bAirwayNumber,
  getAirPort,
} from "@/api/extract/new";
import { getAirport } from "@/api/system/airportList";
import { getTransportAgent, getAirLine } from "@/api/tracker/air";
import numRules from "@/utils/numRules";
import { getAgent } from "@/api/tracker/agent";
import { apis } from "@/api/common";
export default {
  name: "extractNew",
  data() {
    return {
      searchFrom: {
        packing_number: "",
        target_airport: "",
      },
      dataDetails: {
        dept_date: "",
        expected_date: "",
        dbl_packing: [],
      },
      relation: {
        dept_date: "",
        expected_date: "",
      },
      carrierObj: {},
      ruleFrom: {
        carrier_code: [
          {
            required: true,
            message: this.$t("select") + this.$t("carrier_code"),
            trigger: "change",
          },
        ],
        hub: [
          {
            required: true,
            message: this.$t("select") + this.$t("hub"),
            trigger: "change",
          },
        ],
        from_station: [
          {
            required: true,
            message: this.$t("select") + this.$t("from_station"),
            trigger: "change",
          },
        ],
        to_station: [
          {
            required: true,
            message: this.$t("select") + this.$t("to_station"),
            trigger: "change",
          },
        ],
        dept_date: [
          {
            required: true,
            message: this.$t("select") + this.$t("dept_date"),
            trigger: "change",
          },
        ],
        expected_date: [
          {
            required: true,
            message: this.$t("select") + this.$t("expected_date"),
            trigger: "change",
          },
        ],
        load_type: [
          {
            required: true,
            message: this.$t("select") + this.$t("carrier_code"),
            trigger: "change",
          },
        ],
        shipping_mode: [
          {
            required: true,
            message: this.$t("select") + this.$t("shipping_mode"),
            trigger: "change",
          },
        ],
        // clearance_agent: [
        //   {
        //     required: true,
        //     message: this.$t("select") + this.$t("clearagent"),
        //     trigger: "change"
        //   }
        // ],
        flight: [
          {
            required: true,
            message: this.$t("enter") + this.$t("flight"),
            trigger: "blur",
          },
        ],
        mawb: [
          {
            required: true,
            message: this.$t("enter") + this.$t("mawb"),
            trigger: "blur",
          },
        ],
        number_of_bags: [
          {
            required: true,
            message: this.$t("enter") + this.$t("number_of_bags"),
            trigger: "blur",
          },
          { required: true, validator: numRules.isInt, trigger: "blur" },
        ],
        weight: [
          {
            required: true,
            message: this.$t("enter") + this.$t("Weight"),
            trigger: "blur",
          },
          { required: true, validator: numRules.maxFourNum, trigger: "blur" },
        ],
        number_of_shipment: [
          {
            required: true,
            message: this.$t("enter") + this.$t("number_of_shipment"),
            trigger: "blur",
          },
          { required: true, validator: numRules.isInt, trigger: "blur" },
        ],
        // packing_number: [
        //   {
        //     required: true,
        //     type: "array",
        //     message: this.$t("select") + this.$t("packing_number"),
        //     trigger: "change"
        //   }
        // ],
        from_port: [
          {
            required: true,
            message: this.$t("select") + this.$t("departureAirport"),
            trigger: "change",
          },
        ],
        to_port: [
          {
            required: true,
            message: this.$t("select") + this.$t("destinationAirport"),
            trigger: "change",
          },
        ],
        air_line: [
          {
            required: true,
            message: this.$t("select") + this.$t("airLine"),
            trigger: "change",
          },
        ],
        weight: [
          {
            required: true,
            message: this.$t("select") + this.$t("Weight"),
            trigger: "blur",
          },
        ],
        // charging_weight: [
        //   {
        //     required: true,
        //     message: this.$t("select") + this.$t("charge_params"),
        //     trigger: "blur"
        //   }
        // ],
        // volume: [
        //   {
        //     required: true,
        //     message: this.$t("select") + this.$t("square"),
        //     trigger: "blur"
        //   }
        // ],
        quantity: [
          {
            required: true,
            message: this.$t("select") + this.$t("invoicePCS"),
            trigger: "blur",
          },
        ],
      },
      relRuleFrom: {
        dept_date: [
          {
            required: true,
            message: this.$t("select") + this.$t("dept_date"),
            trigger: "change",
          },
        ],
        from_station: [
          {
            required: true,
            message: this.$t("select") + this.$t("from_station"),
            trigger: "change",
          },
        ],
        to_station: [
          {
            required: true,
            message: this.$t("select") + this.$t("to_station"),
            trigger: "change",
          },
        ],
        to_city: [
          {
            required: true,
            message: this.$t("enter") + this.$t("DestinationCity"),
            trigger: "change",
          },
        ],
        expected_date: [
          {
            required: true,
            message: this.$t("select") + this.$t("expected_date"),
            trigger: "change",
          },
        ],
        load_type: [
          {
            required: true,
            message: this.$t("select") + this.$t("carrier_code"),
            trigger: "change",
          },
        ],
        shipping_mode: [
          {
            required: true,
            message: this.$t("select") + this.$t("shipping_mode"),
            trigger: "change",
          },
        ],
        // clearance_agent: [
        //   {
        //     required: true,
        //     message: this.$t("select") + this.$t("clearagent"),
        //     trigger: "change"
        //   }
        // ],
        flight: [
          {
            required: true,
            message: this.$t("enter") + this.$t("flight"),
            trigger: "blur",
          },
        ],
        mawb: [
          {
            required: true,
            message: this.$t("enter") + this.$t("mawb"),
            trigger: "blur",
          },
        ],
        weight: [
          {
            required: true,
            message: this.$t("enter") + this.$t("Weight"),
            trigger: "blur",
          },
          { required: true, validator: numRules.maxFourNum, trigger: "blur" },
        ],
        // packing_number: [
        //   {
        //     required: true,
        //     type: "array",
        //     message: this.$t("select") + this.$t("packing_number"),
        //     trigger: "change"
        //   }
        // ],
        from_port: [
          {
            required: true,
            message: this.$t("select") + this.$t("departureAirport"),
            trigger: "change",
          },
        ],
        to_port: [
          {
            required: true,
            message: this.$t("select") + this.$t("destinationAirport"),
            trigger: "change",
          },
        ],
        air_line: [
          {
            required: true,
            message: this.$t("select") + this.$t("airLine"),
            trigger: "change",
          },
        ],
        weight: [
          {
            required: true,
            message: this.$t("select") + this.$t("Weight"),
            trigger: "blur",
          },
        ],
        // charging_weight: [
        //   {
        //     required: true,
        //     message: this.$t("select") + this.$t("charge_params"),
        //     trigger: "blur"
        //   }
        // ],
        // volume: [
        //   {
        //     required: true,
        //     message: this.$t("select") + this.$t("square"),
        //     trigger: "blur"
        //   }
        // ],
        quantity: [
          {
            required: true,
            message: this.$t("select") + this.$t("invoicePCS"),
            trigger: "blur",
          },
        ],
      },
      loading: false,
      tableData: [],
      bagNum: 0,
      awoNum: 0,
      hubList: [],
      loadTypeList: [],
      shippingModeList: [],
      clearList: [],
      fromStationList: [],
      toStationList: [],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      packingNumList: [],
      packList: [],
      checkAll: false,
      checkAllGroup: [],
      b2bPackList: [],
      b2bCheckAll: false,
      b2bCheckAllGroup: [],
      airList: [],
      baoguanList: [],
      airportList: [],
      airLineList: [],
      HkList: [],
      isSecond: false,
      airportList1: [],
      airportLists1: {},
      transportAgentList: [],
      board_type: [],
    };
  },
  computed: {
    tableTitle() {
      let columns = [];
      columns.push({
        title: this.$t("order_number") + " (" + this.awoNum + ")",
        key: "airway_bill",
        align: "center",
      });
      columns.push({
        title: this.$t("bagCode") + " (" + this.bagNum + ")",
        key: "package_number",
        align: "center",
      });
      return columns;
    },
  },
  mounted() {
    this.getotherList();
  },
  methods: {
    handleCreate(val) {
      this.toStationList.push({
        key: val,
        name: val,
      });
    },
    changeCarrier() {
      this.dataDetails.clearance_agent = "";
      this.dataDetails.to_station = "";
      this.clearList = [];
      this.toStationList = [];
      getExtractConfig({ carrier: this.dataDetails.carrier_code }).then(
        (res) => {
          this.toStationList = res.data.payload.list.ToStation;
        }
      );
    },
    changeTo(key) {
      if (key === "to_station") {
        if (this.airportLists1[this.dataDetails.to_station])
          return (this.airportList1 =
            this.airportLists1[this.dataDetails.to_station]);
        getAirPort({ country: this.dataDetails.to_station }).then((res) => {
          this.airportList1 = res.data.payload;
          this.airportLists1[this.dataDetails.to_station] = res.data.payload;
        });
      }
      if (this.dataDetails.carrier_code && this.dataDetails.to_station) {
        getExtractConfig({
          to_country: this.dataDetails.to_station,
          carrier: this.dataDetails.carrier_code,
        }).then((res) => {
          this.clearList = res.data.payload.list.ClearanceAgent;
        });
      }
    },
    handCheck() {
      this.checkAll = false;
      this.resetSubmit();
      if (this.dataDetails.from_station && this.dataDetails.clearance_agent) {
        let data = {
          clearance_agent_name: this.dataDetails.clearance_agent,
          from_station: this.dataDetails.from_station,
        };
        getClearancePacking(data).then((res) => {
          this.packList = res.data.payload;
        });
        getB2bAirwayNumber({
          clearance_agent_name: this.dataDetails.clearance_agent,
        }).then((res) => {
          this.b2bPackList = res.data.payload;
        });
      }
    },
    getotherList() {
      getExtractConfig().then((res) => {
        this.carrierObj = res.data.payload.CarrierCode;
        this.hubList = res.data.payload.list.Hub;
        this.fromStationList = res.data.payload.list.FromStation;
        // this.toStationList = res.data.payload.list.ToStation;
        this.loadTypeList = res.data.payload.list.LoadType;
        this.shippingModeList = res.data.payload.list.ShippingMode;
      });
      console.log(apis);
      apis.boardType().then((res) => {
        this.board_type = res.data.payload;
      });
      getAgent({ agent_type: "air" }).then((res) => {
        this.airList = res.data.payload.rows;
      });
      getAgent().then((res) => {
        this.baoguanList = res.data.payload.rows;
      });
      getAgent({ agent_type: "port" }).then((res) => {
        this.HkList = res.data.payload.rows;
      });
      getAirport({ status: "ENABLE" }).then((res) => {
        this.airportList = res.data.payload.rows;
      });
      getAirLine().then((res) => {
        this.airLineList = res.data.payload;
      });
      getTransportAgent().then((res) => {
        this.transportAgentList = res.data.payload;
      });
    },
    // 新建二级
    secondClick() {
      // if (this.isSecond) this.$refs["relation"].resetFields();
      this.isSecond = !this.isSecond;
    },
    // 新建提单
    subfun() {
      let data = this.dataDetails;
      if (this.isSecond) data["relation"] = this.relation;
      data.number_of_shipment = this.awoNum;
      data.number_of_bags = this.bagNum;
      add(data).then((res) => {
        if (res.data.code == 0) {
          this.$Message["success"]({
            background: true,
            content: res.data.msg,
          });
          this.resetSubmit();
          this.$refs["dataDetails"].resetFields();
          if (this.isSecond) this.$refs["relation"].resetFields();
          this.isSecond = false;
          setTimeout(()=>{
            location.reload()
          },1500)
        } else {
          this.$Message["error"]({
            background: true,
            content: res.data.msg,
          });
        }
      });
    },
    submitClick() {
      this.$refs["dataDetails"].validate((valid) => {
        if (valid) {
          if (this.isSecond) {
            this.$refs["relation"].validate((rel) => {
              if (rel) {
                this.subfun();
              }
            });
          } else {
            this.subfun();
          }
        }
      });
    },
    SearchSubmit(data) {
      this.loading = true;
      let obj = {
        packing_number: data,
        target_airport: this.dataDetails.from_station,
      };
      postPack(obj)
        .then((res) => {
          this.loading = false;
          if (!res.data.status) {
            this.$Message["error"]({
              background: true,
              content: res.data.msg,
            });
            return;
          }
          this.tableData = res.data.payload.rows;
          this.bagNum = res.data.payload.packageTotal;
          this.awoNum = res.data.payload.airwayTotal;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    resetSubmit() {
      this.bagNum = this.awoNum = 0;
      this.packList = this.dataDetails.packing_number = this.tableData = [];
      this.b2bPackList = this.dataDetails.dbl_packing = [];
    },
    handleCheckAll() {
      this.checkAll = !this.checkAll;
      if (this.checkAll) {
        this.dataDetails.packing_number = this.packList.map((item) => {
          return item.packing_number;
        });
        this.SearchSubmit(this.dataDetails.packing_number);
      } else {
        this.dataDetails.packing_number = this.tableData = [];
        this.awoNum = this.bagNum = 0;
      }
    },
    checkAllGroupChange(data) {
      if (this.dataDetails.packing_number.length === this.packList.length) {
        this.checkAll = true;
      } else {
        this.checkAll = false;
      }
      if (data.length != 0) {
        this.SearchSubmit(data);
      } else {
        this.dataDetails.packing_number = this.tableData = [];
        this.awoNum = this.bagNum = 0;
      }
    },
    b2bCheckAllChange() {
      this.b2bCheckAll = !this.b2bCheckAll;
      if (this.b2bCheckAll) {
        this.dataDetails.dbl_packing = this.b2bPackList.map((item) => {
          return item.packing_number;
        });
      } else {
        this.dataDetails.dbl_packing = [];
      }
    },
    b2bcheckAllGroupChange(data) {
      console.log(this.dataDetails.dbl_packing);
      if (this.dataDetails.dbl_packing.length === this.b2bPackList.length) {
        this.b2bCheckAll = true;
      } else {
        this.b2bCheckAll = false;
      }
      if (!data.length) {
        this.dataDetails.dbl_packing = [];
      }
    },
  },
};
</script>

<style scoped lang="less">
.my-content {
  min-height: 100%;
  display: flex;
}
.left-content {
  width: ~"calc(100% - 500px)";
  min-height: 100%;
  background: #fff;
  padding: 10px;
}
.right-content {
  width: 500px;
  min-height: 100%;
  margin-left: 10px;
  background: #fff;
  padding: 10px;
}
.submit-btn {
  width: 170px;
  margin: 0 20px;
}
.btn-div {
  width: 100%;
  margin-top: 20px;
  display: flex;
  justify-content: center;
}

.bag-code {
  border: 1px solid #dcdee2;
  height: 150px;
  border-radius: 4px;
}
.check-all {
  position: absolute;
  width: 100%;
  top: 0;
  border-bottom: 1px solid #e9e9e9;
  padding: 0 15px;
}
.check-client {
  position: absolute;
  top: 40px;
  width: 100%;
  height: 100%;
  overflow: auto;
  padding: 0 10px;
}
</style>
